import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The old mock login page has been removed. `/login` now forwards to the single
 * genuine authentication flow at `/auth`.
 */
export const Route = createFileRoute("/login")({
  beforeLoad: () => {
    throw redirect({ to: "/auth", search: { redirect: "/portal" } });
  },
});
